import { MessagesStatus } from 'app/models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import {  FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
@Component({
  selector: 'app-relacion-docnegociable-fondo',
  templateUrl: './relacion-docnegociable-fondo.component.html',
  styleUrls: ['./relacion-docnegociable-fondo.component.scss'],
  providers: [MessagesStatus]
})
export class RelacionDocnegociableFondoComponent implements OnInit {

   @Output() cerrarPopUp: EventEmitter<boolean> = new EventEmitter();
   @Output() refresh: EventEmitter<boolean> = new EventEmitter();
   @Input() listaGarantias: any;
   @Input() listaFondos: any;
   @Input() listaDN: any;
   @Input() Comprobante: any;
   @Input() flag: any;
   loading:boolean;
   user : any;
   datos:any = {};
   myForm: FormGroup;
   detalleFondo: any;
   titulo: any='';
   dataEnviar: any = {};
   disableButton:boolean;
   idGarantia: any = '' ; 
  constructor(private riesgoService: RiesgoService,private fb: FormBuilder,private msgStatus : MessagesStatus) { 

    this.user = JSON.parse(sessionStorage.getItem('UserActive')); 
    
  }
  ngOnInit(){
    this.myForm = this.fb.group({
      Usuario: this.user.Usuario,
      Comprobantes: this.fb.array([])
    })

    if (this.flag == 'edit') {
      this.titulo = 'Editar Financiamiento'
      this.datos.Comprobantes = []
      let i = 0;
      for (let item of this.listaDN) {  
      this.datos.Comprobantes.push(item)
      }
      this.setDocumentosN();   
    }else if(this.flag == 'ver'){
      if(this.Comprobante.cantidad_fondos_financiados_activos == 0){
        this.disableButton = true;
      }
      this.titulo = 'Detalle Financiamiento'
      this.datos.Comprobantes = []
      this.datos.Comprobantes.push(this.Comprobante)
      this.setDocumentosN(); 
    }else{
      this.titulo = 'Agregar Financiamiento'
      this.datos.Comprobantes = []
      let i = 0;
      for (let item of this.listaDN) {
        let newArray :any = {}
        newArray.idFondo = '';
        newArray.Porcentaje = 100;
        newArray.Monto_Financiamiento_Fondo = item.VNPP;
        newArray.Moneda = item.Moneda;
  
        this.datos.Comprobantes.push(item)
        this.datos.Comprobantes[i].Fondos = []
        this.datos.Comprobantes[i].Fondos.push(newArray) ;
        i++;
      }
      this.setDocumentosN();
    }
  }

 get groupComprobantes() {
  return <FormArray>this.myForm.get('Comprobantes');
 }
 get groupFondos() {
  return <FormArray>this.myForm.get('Comprobantes').value;
 }

  addNewFondo(control,index) {
    let suma = 0;
    for(let item of control.value){
         suma += item.Porcentaje
    }
    let porcentajeRestante = 100 - suma
    control.push(
      this.fb.group({
        idFondo: ['',[Validators.required]],
        Porcentaje: [(porcentajeRestante).toFixed(2), [Validators.required, Validators.min(1),Validators.max(100)]],
        Monto_Financiamiento_Fondo: [((this.groupFondos[index].VNPP * porcentajeRestante)/100).toFixed(2),[Validators.required] ],
        Estado:''
      })) 
  }

  deleteFondo(control, index) {
    if (control.value.length == 1) {
      return
    }
    control.removeAt(index)
  }

  setDocumentosN() {
    let control = <FormArray>this.myForm.controls.Comprobantes;

    this.datos.Comprobantes.forEach(x => {
      if (x.financiamiento_garantia != null || x.financiamiento_garantia != undefined) {
        this.idGarantia = x.financiamiento_garantia.idGarantia
      }else{
        this.idGarantia = '';
      }
      control.push(this.fb.group({ 
        idComprobante:  [{value:x.idComprobante,disabled:false},[Validators.required]],
        idGarantia:[this.idGarantia],
        VNPP:[x.VNPP,[Validators.required]],
        Moneda:  [{value:x.Moneda_Dsc,disabled:true}],
        Fondos: this.setFondos(x) }))
    })
  }

  setFondos(x) {
    let arr = new FormArray([])
    if (this.flag == 'ver') {
      x.financiamiento_fondo.forEach(y => {
        arr.push(this.fb.group({ 
          idFondo: [y.idFondo,[Validators.required]] ,
          Porcentaje:[{value:(y.Porcentaje)*100, disabled:true},[Validators.required, Validators.min(1),Validators.max(100)]],
          Monto_Financiamiento_Fondo: [{value:y.Monto_Financiamiento_Fondo, disabled:true},[Validators.required]],
          Estado: [{value:y.Estado_Descripcion, disabled:true}]
        }))
      })
      return arr;
    }else if(this.flag == 'edit'){
      x.financiamiento_fondo.forEach(y => {
        if (y.Estado == 'P') {
          arr.push(this.fb.group({ 
            idFondo: [y.idFondo,[Validators.required]] ,
            Porcentaje:[{value:(y.Porcentaje)*100,disabled:false},[Validators.required, Validators.min(1),Validators.max(100)]],
            Monto_Financiamiento_Fondo: [y.Monto_Financiamiento_Fondo,[Validators.required]],
            Estado: [{value:y.Estado, disabled:true}]
          }))
        } 
      })
      return arr;
    }else{
      x.Fondos.forEach(y => {
        arr.push(this.fb.group({ 
          idFondo: [y.idFondo,[Validators.required]] ,
          Porcentaje:[y.Porcentaje,[Validators.required, Validators.min(1),Validators.max(100)]],
          Monto_Financiamiento_Fondo: [x.VNPP ,[Validators.required]],
          Estado: [{value:y.Estado, disabled:true}]
        }))
      })
      return arr;
    }
  }

  isTotPorcentajeValido(porcentaje: number, index: number,j : number) {

    let suma = 0;
    for(let item of this.groupFondos[index].Fondos){
         suma += item.Porcentaje
    }

    this.myForm.get('Comprobantes.'+index+'.Fondos.'+j+'.Monto_Financiamiento_Fondo').patchValue(((this.groupFondos[index].VNPP*this.groupFondos[index].Fondos[j].Porcentaje)/100).toFixed(2) )

  }

  isTotMontoValido(monto: number, index: number,j : number) {

    let suma = 0;
    for(let item of this.groupFondos[index].Fondos){
         suma += item.Monto_Financiamiento_Fondo
    }
    this.myForm.get('Comprobantes.'+index+'.Fondos.'+j+'.Porcentaje').patchValue(((monto*100)/this.groupFondos[index].VNPP).toFixed(2) )

  }

 GuardarOperacionFondo(){
   
   if (this.flag == 'edit') {
    this.dataEnviar.Usuario = this.user.Usuario;
    this.dataEnviar.idComprobante = this.groupFondos[0].idComprobante;
    this.dataEnviar.idGarantia = this.groupFondos[0].idGarantia;
    this.dataEnviar.VNPP = this.groupFondos[0].VNPP;
    this.dataEnviar.Fondos = [];

    for (let item of this.groupFondos[0].Fondos) {
      this.dataEnviar.Fondos.push(item)
      
    }
    
    Swal.fire({
      title: '¿Desea continuar?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, Continuar',
      cancelButtonText: 'No, Cancelar',
      heightAuto: false
  }).then((result) => {
    if (result.value) {
    this.actualizar();
  } 
  });

   }else{
    Swal.fire({
      title: '¡Espere!',
      text:'Estamos guardando la información',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
    });
    Swal.showLoading();
    this.riesgoService.AsignarFondosDN(this.myForm.getRawValue())
        .subscribe( resp => {
            Swal.fire({
              title: "¡Éxito!",
              text: 'guardado correctamente.',
              type: "success",
              allowOutsideClick: false,
              heightAuto: false
            }).then( resp2 => {
              if (resp2.value == true){
                this.refresh.emit();
                this.cerrarPopUp.emit();
              }
          });
    },(err2: HttpErrorResponse)=> {
      let error;
      if (err2.error.error == undefined) {
        error = err2.error;
      }else if(err2.error.error.errorMessage != undefined){
        error = err2.error.error.errorMessage;
      }
      Swal.fire({
        title: "Error!",
        text: error,
        type: "error",
        allowOutsideClick: false,
        heightAuto: false
      })        
    })  
   }
   
}
actualizar(){
  Swal.fire({
    title: '¡Espere!',
    text:'Estamos actualizando la información.',
    type:'info',
    allowOutsideClick:false,
    heightAuto: false
  });
  Swal.showLoading();
  this.riesgoService.ActualizarFondosDN(this.myForm.getRawValue())
      .subscribe( resp => {
          Swal.fire({
            title: "¡Éxito!",
            text: 'actualizado correctamente',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then( resp1 => {
            if (resp1.value == true){
              this.cerrarPopUp.emit();
              this.refresh.emit();
            }
        });
  },(err: HttpErrorResponse)=> {
    let error;
    if (err.error.error == undefined) {
      error = err.error;
    }else if(err.error.error.errorMessage != undefined){
      error = err.error.error.errorMessage;
    }
    Swal.fire({
      title: "Error!",
      text: error,
      type: "error",
      allowOutsideClick: false,
      heightAuto: false
    })      
  })  
}

LiberarOperacionFondo(){

  this.dataEnviar.Usuario = this.user.Usuario;
  this.dataEnviar.idComprobante = this.Comprobante.idComprobante;
  
  Swal.fire({
    title: 'Seguro que desea liberar el Fondo?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si, Continuar',
    cancelButtonText: 'No, Cancelar',
    heightAuto: false
  }).then((result) => {
  if (result.value) {
  Swal.fire({
    title: '¡Espere!',
    text:'Estamos guardando la información.',
    type:'info',
    allowOutsideClick:false,
    heightAuto: false
  });
  Swal.showLoading();
  this.riesgoService.LiberarFondoDN(this.dataEnviar)
      .subscribe( resp => {
          Swal.fire({
            title: "¡Éxito!",
            text: 'Fondo liberado correctamente',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then( resp3 => {
            if (resp3.value == true){
              this.cerrarPopUp.emit();
              this.refresh.emit();
            }
        });
    },(err1: HttpErrorResponse)=> {
        let error;
        if (err1.error.error == undefined) {
          error = err1.error;
        }else if(err1.error.error.errorMessage != undefined){
          error = err1.error.error.errorMessage;
        }
        Swal.fire({
          title: "Error!",
          text: error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        })        
      })  
    } 
  });

}

  CerrarPopUp(){
    this.cerrarPopUp.emit();
  }

}
